export default class ScrollSlideshow {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {};
      this.reset();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Sets/Resets the slideshow
  //===========================================================================

  reset() {
    this.state = {};
    this.state.$slideshow = $('.js-scroll-slideshow');

    if (this.state.$slideshow.length) {
      this.state.$slideshowHeader = this.state.$slideshow.find('.js-scroll-slideshow-header');
      this.state.$bgSlides = this.state.$slideshow.find('.js-scroll-slideshow-bg-slide');
      this.state.hasSlideshow = this.state.$bgSlides.length > 1;
      this.state.desktopSize = window.innerWidth > 750;
      $('body').addClass('scroll-slideshow-active');
    } else {
      this.state.hasSlideshow = false;
    }
  }

  //===========================================================================
  // Updates screen size
  //===========================================================================

  onResize() {
    this.state.desktopSize = window.innerWidth > 750;
  }

  //===========================================================================
  // Moves slides on page scroll
  //===========================================================================

  adjustSlideshow() {
    if (this.state.hasSlideshow && this.state.desktopSize) {
      const headerBounds = this.state.$slideshowHeader[0] ? this.state.$slideshowHeader[0].getBoundingClientRect() : null;
      const headerBottom = headerBounds ? headerBounds.top + headerBounds.height : 0;
      let slidesToHide = 0;

      for (let i = this.state.$bgSlides.length - 1; i >= 0; i--) {
        const slide = this.state.$bgSlides[i];
        const index = slide ? slide.getAttribute('data-index') : null;
        const slideBounds = slide ? slide.getBoundingClientRect() : null;
        const slideTop = slideBounds ? slideBounds.top : 0;

        if (slideTop < (window.innerHeight - 50)) {
          slidesToHide = index;
          break;
        }
      }

      this.adjustSlideshowClasses(slidesToHide);
      this.adjustBodyClasses();
    }
  }

  //===========================================================================
  // Adds/Removes classes for slideshow
  //===========================================================================

  adjustSlideshowClasses(slidesToHide) {
    const slideshowClass = `hide-${ slidesToHide }`;
    const $html = $('html');

    if (!this.state.$slideshow.hasClass(slideshowClass)) {
      if (slidesToHide > 0) {
        $html.addClass('no-scroll');
        setTimeout(() => {
          $html.removeClass('no-scroll');
        }, 500);
      }

      this.state.$slideshow.removeClass('hide-0 hide-1 hide-2 hide-3');
      this.state.$slideshow.addClass(slideshowClass);
    }
  }

  //===========================================================================
  // Adds/Removes body classes for slideshow
  //===========================================================================

  adjustBodyClasses() {
    const $body = $('body');
    const headerTop = this.state.$slideshowHeader[0] ? this.state.$slideshowHeader[0].getBoundingClientRect().top : null;

    if (headerTop !== null && headerTop > -50) {
      $('body').addClass('scroll-slideshow-active');
    } else {
      $('body').removeClass('scroll-slideshow-active');
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(window).on('scroll', this.adjustSlideshow.bind(this));
    $(window).on('resize', this.onResize.bind(this));
    $(document).on('historyChange', this.reset.bind(this));
  }
}
